<template>
	<div></div>
</template>

<script>
export default {
  name: "not-found"
};
</script>

<style lang="scss">
</style>
